import request from '@/utils/sap-request'

/**
 * 销售计划量签约详情查询
 * @param {*} params
 */
export function getSpctById(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_spct_by_id',
    method: 'post',
    data
  })
}
/**
 * 销售计划量签约新增单
 * @param {*} params
 */
export function spctNewOrder(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/spct_new_order',
    method: 'post',
    data
  })
}
/**
 * 销售计划量签约新增单列表
 * @param {*} params
 */
export function getSpct(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_spct',
    method: 'post',
    data
  })
}
/**
 * 销售计划量签约新增单列表
 * @param {*} params
 */
export function spctOrderPlsp(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/spct_order_plsp',
    method: 'post',
    data
  })
}
/**
 * 申请变更单
 * @param {*} params
 */
export function spctChgOrder(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/spct_chg_order',
    method: 'post',
    data
  })
}
/**
 * 查询是否大区副总
 * @param {*} params
 */
export function getCenterFz(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_center_fz',
    method: 'post',
    data
  })
}
/**
 * 销售折扣查询
 * @param {*} params
 */
export function getDhk(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_dhk',
    method: 'post',
    data
  })
}
/**
 * 销售折扣查询id详情
 * @param {*} params
 */
export function getDhkById(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_dhk_by_id',
    method: 'post',
    data
  })
}
/**
 * 销售折扣抵消
 * @param {*} params
 */
export function getSubmitDhk(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/submit_dhk',
    method: 'post',
    data
  })
}
/**
 * 销售折扣明细查询
 * @param {*} params
 */
export function getDhkDetail(data) {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/get_dhk_detail',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/sap/signing-sap.js